import { masterSequence as master } from './master';
import { mainMenuSequence as mainMenu } from './mainMenu';

export const sequences = {
  master,
  mainMenu
};

export type SequenceType = keyof typeof sequences;
